import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DashboardStat from '@shared/ui/dashboard/DashboardStat';
import { ListData } from '@shared/ui/parts';
import {
  donutChartOptions,
  getColorsByPercentage,
} from '@utils/charts-helpers';

export default function DashboardActiveCards() {
  const { tariff } = useSelector((state) => state.tariff);
  const { t } = useTranslation();
  const activeCardsCount = tariff?.active_cards_count ?? 0;
  const activeCardsLimit = tariff?.active_cards_limit ?? 0;

  const chartData = useMemo(() => {
    if (!tariff) return null;
    return {
      series: [
        activeCardsCount,
        Math.max(0, activeCardsLimit - activeCardsCount),
      ],
      options: {
        ...donutChartOptions.options,
        colors: getColorsByPercentage(activeCardsCount, activeCardsLimit),
      },
    };
  }, [tariff]);

  const listData = [
    {
      label: t('available'),
      value: `${tariff?.count_free_card_used ?? 0} / ${tariff?.count_free_card ?? 0}`,
      showFreeCards: true,
    },
    {
      label: t('available_cards_per_day'),
      value: `${tariff?.daily_card_limit_used ?? 0} / ${tariff?.daily_card_limit ?? 0}`,
    },
  ];

  return (
    <div className="dashboardStat__block">
      <DashboardStat
        title={t('active_cards')}
        value={`${activeCardsCount} <span> / ${activeCardsLimit}</span>`}
        chartData={chartData}
      />
      <ListData listData={listData} />
    </div>
  );
}
